import { format, formatDistance, isAfter, isBefore, isEqual, set } from 'date-fns'
import { formatInTimeZone, zonedTimeToUtc } from 'date-fns-tz'

import _ from 'lodash'
import { config } from './config'
import { getServerDate } from './serverTimeUtil'

const JSON_TIMESTAMP = 'yyyy-MM-dd HH:mm:ss.SSSSSS'
const JSON_DATE = `yyyy-MM-dd`

export const TIMEZONE = config.DB_TIMEZONE || 'America/Toronto'

export const parseDateTime = (val) => {
  if (_.isNil(val)) {
    return null
  }

  if (_.isDate(val)) {
    return val
  }

  if (_.isString(val) && val.endsWith('Z')) {
    return new Date(val)
  }

  return zonedTimeToUtc(val, TIMEZONE)
}

export const formatDateTime = (dateTimeString, formatString) => {
  if (_.isNil(dateTimeString)) {
    return 'N/A'
  }

  try {
    const date = _.isDate(dateTimeString) ? dateTimeString : parseDateTime(dateTimeString)
    return formatInTimeZone(date, TIMEZONE, formatString)
  } catch (e) {
    return '?'
  }
}

export const LONG_DATE = 'MMMM d, Y'
export const MEDIUM_DATE = 'MMM d, Y'
export const SHORT_DATE = 'yyyy/MM/dd'
export const LONG_TIME = 'h:mm:ss a'
export const SHORT_TIME = 'h:mm a'
export const LONG_DATETIME = `${LONG_DATE}' at '${LONG_TIME}`
export const MEDIUM_DATETIME = `${MEDIUM_DATE}' '${SHORT_TIME}`
export const SHORT_DATETIME = `${SHORT_DATE}' '${SHORT_TIME}`

// Public format functions.
export const longDateTime = (val) => formatDateTime(val, LONG_DATETIME)
export const defaultDateTime = (val) => formatDateTime(val, MEDIUM_DATETIME)
export const shortDateTime = (val) => formatDateTime(val, SHORT_DATETIME)
export const defaultDate = (val) => formatDateTime(val, MEDIUM_DATE)
export const defaultTime = (val) => formatDateTime(val, LONG_TIME)
export const jsonDateShort = (val) => formatDateTime(val, JSON_DATE)
export const jsonDate = (val) => formatDateTime(val, JSON_TIMESTAMP)

export const durationInWords = (val, addSuffix = true) =>
  _.isNil(val)
    ? 'N/A'
    : formatDistance(parseDateTime(val), getServerDate(), {
        addSuffix,
        includeSeconds: false,
      })

export const isBetween = (date, start, end) => {
  date = set(date, { milliseconds: 0, seconds: 0, minutes: 0, hours: 0 })
  start = set(start, { milliseconds: 0, seconds: 0, minutes: 0, hours: 0 })
  end = set(end, { milliseconds: 0, seconds: 0, minutes: 0, hours: 0 })
  const beforeEnd = isBefore(date, end) || isEqual(date, end)
  const afterStart = isAfter(date, start) || isEqual(date, start)
  return beforeEnd && afterStart
}
